// App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { TenantProvider } from './context/TenantContext';
import ProtectedRoute from './admin/components/ProtectedRoute';
import AdminPanel from './admin/pages/AdminPanel';
import UserManagement from './admin/pages/UserManagement';
import TenantManagement from './admin/pages/TenantManagement';
import SubscriptionManagement from './admin/pages/SubscriptionManagement';
import SuperAdminIncidents from './admin/pages/SuperAdminIncidents';
import SuperAdminTrackingReportsPage from './admin/pages/TrackingReportsPage';
import './styles/Admin-global.css';
import Login from './admin/pages/Login';

function App() {
  return (
    <TenantProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />

          {/* Admin Routes (Protected) */}
          <Route element={<ProtectedRoute roles={['super-admin', 'tenant-admin']} />}>
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/admin/users" element={<UserManagement />} />
            <Route path="/admin/tenants" element={<TenantManagement />} />
            <Route 
              path="/admin/subscription/:tenantId" 
              element={<SubscriptionManagement />} 
            />
          </Route>

        <Route path="/admin/incidents" element={<SuperAdminIncidents />} />
        <Route path="/admin/trackingreports" element={<SuperAdminTrackingReportsPage />} />
          {/* Redirect/catch-all route */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </TenantProvider>
  );
}

export default App;
